import { Injectable } from '@angular/core';


export class TranslationSet {
   public languange: string;
   public values: {[key: string]: string} = {};
}

@Injectable()
export class TranslationService {

    public languages = ['ge', 'eng'];

    public language = 'ge';

    private dictionary: {[key: string]: TranslationSet} = {
        'ge' : {
            languange: 'ge',
            values: {
                'once' : 'ერთჯერადი',
                'multiple' : 'მრავალჯერადი',
                'standart' : 'სტანდარტი',
                'comfort' : 'კომფორტი',
                'premium' : 'პრემიუმი',
                'F' : 'მდედრ.',
                'M' : 'მამრ.',
                'GEL' : '₾',
                'USD' : '$',
                'EUR' : '€',
            }
        },
        'eng' : {
            languange: 'eng',
            values: {
                'example' : 'Example'
            }
        }
    };

    constructor() { }

    translate(value: string): string {
        if ( this.dictionary[this.language] != null) {
            return this.dictionary[this.language].values[value];
        }
    }
}
